import dom, { Fragment } from "../../../dist/jsx-render/dom"
import { ColumnBase } from "./ColumnBase";
import { RadioButtonComponent } from "../../Components/RadioButtonComponent";
import { YesNoData } from "../../Areas/Admin/Shared/Models/AttributesYesNo";
import { MsoTable } from "./MsoTable";
import { ITableColumn } from "./ITableColumn";
import { ColorHelper } from "../ColorHelper";

/**
 * This column is used for YesNo or fields with boolean values for inline editing.
 */
export class ColumnYesNoRadioButtons extends ColumnBase {

    private key: string;

    // Use any here, because YesNoData has PascalCase properties. But when the attributes are serialized with the column definition
    // it will have camelCase properties.
    private attributes: any; //YesNoData;

    constructor(protected table: MsoTable, protected def: ITableColumn, protected rootId: string) {
        super(table, def, rootId);

        if (def.attributes) {
            this.attributes = def.attributes;
        }
    }

    public getContent = (row: any): HTMLElement => {
        this.key = this.field;
        if (this.field + "_Raw" in row) {
            this.key = this.field + "_Raw";
        }

        if (this.def.visibilityField == 'canBeMandatory') {
            if (this.isCellVisible(row) == false) {
                return <i className="far fa-square mt-checkbox d-none"></i>;
            }
            else {
                if (row[this.key] == 'true' || row[this.key] === true) {
                    return this.getRadioButtons(true, row);
                }
                else if (row[this.key] == 'false' || row[this.key] === false) {
                    return this.getRadioButtons(false, row);
                } else {
                    return this.getRadioButtons(undefined, row);
                }
            }
        }
        else {
            if (this.isCellVisible(row)) {
                if (row[this.key] == 'true' || row[this.key] === true) {
                    return this.getRadioButtons(true, row);
                }
                else if (row[this.key] == 'false' || row[this.key] === false) {
                    return this.getRadioButtons(false, row);
                } else {
                    return this.getRadioButtons(undefined, row);
                }
            }
        }

    }

    private getRadioButtons = (value: boolean, row: any) => {
        let inputYes: HTMLInputElement = <input id={`${this.field}_${row["Id"]}_yes`} type="radio" className="column-radio-yes form-check-input" name={`radioGroup_${this.field}_${row["Id"]}`} />
        let inputNo: HTMLInputElement = <input id={`${this.field}_${row["Id"]}_No`} type="radio" className="column-radio-no form-check-input" name={`radioGroup_${this.field}_${row["Id"]}`} />

        if (this.def.isDisabled) {
            inputYes.disabled = true;
            inputNo.disabled = true;
        }

        if (value === true) {
            inputYes.checked = true;
            inputYes.setAttribute("checked", null);
        } else if (value === false) {
            inputNo.checked = true;
            inputNo.setAttribute("checked", null);
        }


        // Add event listeners
        inputYes.addEventListener("change", (event: Event) => {
            this.onRadioButtonSelected(event, row, inputYes, inputNo);
        });

        inputNo.addEventListener("change", (event: Event) => {
            this.onRadioButtonSelected(event, row, inputYes, inputNo);
        });

        let element = <div className="colum_yes_no_container">
            <div className="color-radio-button form-check-inline form-check">
                {inputYes}
                <label className="form-check-label-maintain-color" for={`${this.field}_${row["Id"]}_yes`}>{Resources.Massnahme.yes}</label>
            </div>
            <div className="color-radio-button form-check-inline form-check">
                {inputNo}
                <label className="form-check-label-maintain-color" for={`${this.field}_${row["Id"]}_No`}>{Resources.Massnahme.no}</label>
            </div>
        </div>

        // set initial colors
        this.setColors(inputYes, inputNo);

        return element;
    }

    private onRadioButtonSelected = (event: Event, row: any, inputYes: HTMLInputElement, inputNo: HTMLInputElement) => {
        let target = event.target as HTMLInputElement;

        if (target == inputYes) {
            // set string values, because the list also has string values in the field xxx_raw
            row[this.key] = "true";
        } else if (target == inputNo) {
            row[this.key] = "false";
        }

        this.setColors(inputYes, inputNo);

        if (this.table.props.onModelChanged) {
            this.table.props.onModelChanged(this.field, row, this.key);
        }
    }

    private setColors = (inputYes: HTMLInputElement, inputNo: HTMLInputElement) => {
        if (this.attributes) {
            if (this.attributes.yesColor) {
                this.updateRadioButtonBackgroundColor(inputYes, this.attributes.yesColor);
            }

            if (this.attributes.noColor) {
                this.updateRadioButtonBackgroundColor(inputNo, this.attributes.noColor);
            }
        }
    }

    // TODO move to class and substitute here and in yesnocontrol
    private updateRadioButtonBackgroundColor(input: HTMLInputElement, color: string) {
        if (!color || color == "" || color == "#ffffff") return;

        if (input.checked) {
            input.parentElement.style.backgroundColor = color;
            input.parentElement.style.color = this.getTextColor(color);
            if (input.disabled) {
                input.parentElement.style.opacity = '.7';
            }
        }
        else {
            input.parentElement.style.backgroundColor = "#ffffff";
            input.parentElement.style.color = "#000000";
        }
    }

    public getTextColor(color: string): string {
        return ColorHelper.getContrastingTextColor(color);
    }

    public createCell(rowModel: any, idField: string): HTMLElement {
        const cell = super.createCell(rowModel, idField);
        if (this.isEditable && this.isCellVisible(rowModel)) {
            cell.classList.add("pointer");
            cell.classList.add("justify-content-center");
        }
        return cell;
    }
}